<template>
  <section class="ap-stats">
    <div class="ap-stat">
      <div class="ap-stat-head">
        <span class="ap-stat-label">Total Clients</span>
        <span class="ap-stat-icon ap-si-gold"><fa-icon :icon="['fas', 'users']" /></span>
      </div>
      <div class="ap-stat-value">{{ totalClients }}</div>
      <div class="ap-stat-foot">
        <span class="ap-delta ap-delta-up"><fa-icon :icon="['fas', 'arrow-up']" /> {{ joinedThisMonth }}</span>
        added this month
      </div>
    </div>
    <div class="ap-stat">
      <div class="ap-stat-head">
        <span class="ap-stat-label">Joined This Month</span>
        <span class="ap-stat-icon ap-si-green"><fa-icon :icon="['fas', 'check-circle']" /></span>
      </div>
      <div class="ap-stat-value">{{ joinedThisMonth }}</div>
      <div class="ap-stat-foot">new accounts this month</div>
    </div>
    <div class="ap-stat">
      <div class="ap-stat-head">
        <span class="ap-stat-label">Joined This Week</span>
        <span class="ap-stat-icon ap-si-tan"><fa-icon :icon="['fas', 'user-plus']" /></span>
      </div>
      <div class="ap-stat-value">{{ joinedThisWeek }}</div>
      <div class="ap-stat-foot">in the last 7 days</div>
    </div>
    <div class="ap-stat">
      <div class="ap-stat-head">
        <span class="ap-stat-label">Showing</span>
        <span class="ap-stat-icon ap-si-client"><fa-icon :icon="['fas', 'th-large']" /></span>
      </div>
      <div class="ap-stat-value">{{ filteredCount }}</div>
      <div class="ap-stat-foot">matching current filter</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'admin-stat-cards',
  props: {
    totalClients: { type: Number, default: 0 },
    joinedThisMonth: { type: Number, default: 0 },
    joinedThisWeek: { type: Number, default: 0 },
    filteredCount: { type: Number, default: 0 }
  }
}
</script>
